export default function Spinner(props) {
  return (
    <div>
      <div className="loader-wait loader-visible loader-medium">
        <div>Please wait</div>
      </div>
    </div>
  );
}
